import { z } from "zod";
import { DateTypeSchema } from "./core.schema";

// Schemas

export const TermsAndConditionsSchema = z.object({
  createdAt: DateTypeSchema,
  updatedAt: DateTypeSchema,
  version: z.number(),
  url: z.string(),
});
